<i18n lang="yaml" locale="en">
  edit field: Edit field
  type: Type
  input type: Input type
  label: Label
  button text: Button text
  text: Text
</i18n>

<i18n lang="yaml" locale="de">
  edit field: Feld bearbeiten
  type: Typ
  input type: Input-Typ
  label: Beschriftung
  button text: Button Text
  text: Text
</i18n>

<template>
  <transition name="fade">
    <div class="editor scroll-y">
      <div class="header">
        <h3>{{ $t('edit field') }}</h3>
        <close
          size="s"
          @click="$emit('close')"
        />
      </div>
      <div class="body">
        <radio
          class="form-group"
          :type="String"
          :choices="$parent.$options.fieldOptions"
          name="type"
          :value="field.type"
          @input="save('type', $event)"
        >
          {{ $t('type') }}
        </radio>
        <radio
          class="form-group"
          :type="String"
          :choices="$parent.$options.inputOptions"
          name="inputType"
          :value="field.inputType"
          @input="save('inputType', $event)"
          v-if="field.type === 'input' && showInputOptions"
        >
          {{ $t('input type') }}
        </radio>
        <tw-text
          class="form-group"
          name="label"
          :value="field.label"
          @input="updateLabel($event)"
          v-if="field.type !== 'submit'"
        >
          {{ $t('label') }}
        </tw-text>
        <tw-text
          class="form-group"
          name="buttonText"
          :value="field.buttonText"
          @input="save('buttonText', $event)"
          v-if="field.type === 'submit'"
        >
          {{ $t('button text') }}
        </tw-text>
        <tw-text
          class="form-group"
          name="text"
          :value="field.text"
          @input="save('text', $event)"
          v-if="field.type === 'staticText'"
        >
          {{ $t('text') }}
        </tw-text>
      </div>
    </div>
  </transition>
</template>

<script>
import Close from '@/components/icons/Close'
import Radio from '@/components/editor/input/Radio'
import Text from '@/components/editor/input/Text'

export default {
  name: 'FormFieldEditor',
  components: {
    Close,
    Radio,
    twText: Text
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      field: this.value,
      /* hide input options until we have more than one */
      showInputOptions: false
    }
  },
  methods: {
    t (...args) {
      return this.$parent.t(...args)
    },
    updateLabel (event) {
      this.save('label', event)
      this.save('placeholder', event)
    },
    save (key, value) {
      this.field[key] = value
      this.$emit('input', this.field)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

  .editor {
    padding-bottom: 25px;
    left: 37.5%;
    top: 25%;
    width: 25%;
    height: 50%;
    position: fixed;
    z-index: z(formFieldEditor);
    background-color: rgba($color-main-darker, 0.97);
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5em;
    letter-spacing: 0.5pt;
    box-shadow: 0 0 20px rgba(#000, 0.5);

    .body {
      padding: 40px;

      /deep/ .form-group {
        margin-top: 40px;
        font-size: 0.75rem;
        font-weight: 300;
        color: $color-main;
      }
    }

    .header {
      position: sticky;
      top: 0px;
      left: 0px;
      width: 100%;
      background-color: darken($color-main-darker, 5);
      padding: 15px 40px;
      display: flex;
      justify-content: center;

      h3 {
        margin: 0 auto 0 0;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0.35pt;
        color: $color-main;
      }
    }
  }
</style>
